import { Logo } from '../brand/Logo';

/** Small always-on-top brand mark over the basemap — non-interactive so it never
 * blocks map dragging/clicks, low z-index so floating panels (selected object
 * card, etc.) can sit above it in the same corner without visual conflict. */
export function MapBrandWatermark() {
  return (
    <div className="pointer-events-none absolute bottom-6 left-6 z-[5] flex items-center gap-1.5 rounded-lg bg-bg-surface/75 px-2.5 py-1.5 shadow-sm backdrop-blur-sm">
      <Logo variant="light" size={16} />
    </div>
  );
}
